export default __webpack_public_path__ + "static/media/signup-side.2847c5e5.png";